/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./Factory"], function (require, exports, Factory_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var StoreManager = /** @class */ (function (_super) {
        __extends(StoreManager, _super);
        function StoreManager() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        /**
         * Get an instance of the Store.
         */
        StoreManager.GetStore = function (storeClass, instanceId) {
            return _super.getInstance.call(this, StoreManager).getObject(storeClass, instanceId);
        };
        StoreManager.CreateStore = function (storeClass, instanceId, args) {
            return _super.getInstance.call(this, StoreManager).createObject(storeClass, instanceId, args);
        };
        StoreManager.DeleteStore = function (storeClass, instanceId) {
            _super.getInstance.call(this, StoreManager).removeObject(storeClass, instanceId);
        };
        StoreManager.dispose = function () {
            return _super.getInstance.call(this, StoreManager).dispose();
        };
        return StoreManager;
    }(Factory_1.Manager));
    exports.StoreManager = StoreManager;
});
